import API_BASE_URL from "../../../../../Constants";

export const deleteCustomer = async (customerId) => {
  const response = await fetch(
    `${API_BASE_URL}/api/setup/customers/${customerId}`,
    {
      method: "DELETE",
      credentials: "include",
    }
  );
  const message = await response.text();
  if (!response.ok) throw new Error(message);

  return message;
};
